export const white = "#ffffff";
export const black = "#000000";

export const plum900 = "#191628";
export const plum700 = "#2E2A44";
export const plum500 = "#59556B";
export const plum400 = "#8C899A";
export const plum300 = "#CBCAD0";
export const plum200 = "#E0DFE4";
export const plum100 = "#F1F1F1";

export const teal700 = "#00C0C0";
export const teal500 = "#1BD4D4";
export const teal300 = "#A3E4E4";
export const teal100 = "#D0F1F1";

export const coral700 = "#DA4534";
export const coral500 = "#EE6252";
export const coral300 = "#F3A095";
export const coral100 = "#FFE5E1";

export const blue700 = "#1891FF";
export const blue500 = "#64B5FF";
export const blue300 = "#AAD6FF";
export const blue100 = "#DFEFFE";

export const yellow700 = "#E8E204";
export const yellow500 = "#E7E34E";
export const yellow300 = "#EEEC94";
export const yellow100 = "#F6F5C5";
